import StringField from "./StringField";
import SelectField from "./SelectField";
import DateField from "./DateField";
import DecimalField from "./DecimalField";
import NumberField from "./NumberField";
import EmailField from "./EmailField";
import FileField from "./FileField";
import NameField from "./NameField";
import RichTextField from "./RichTextField";
import CheckboxField from "./CheckboxField";
import CountrySelectField from "./CountrySelectField";
import ZipField from "./ZipField";
import StateAsyncField from "./StateAsyncField";
import CountyAsyncField from "./CountyAsyncField";
import CityAsyncField from "./CityAsyncField";
import AssignmentMethodField from "./AssignmentMethodField";
import TagField from "./TagField";
import DateWithTimezoneField from "./DateWithTimezoneField";
import { FIELD_TYPE } from "../constants/fieldTypes";

export const FIELD_COMPONENT_REGISTRY = Object.freeze({
  [FIELD_TYPE.STRING]: StringField,
  [FIELD_TYPE.TEXT]: StringField,
  [FIELD_TYPE.SINGLE_CHOICE_LIST]: SelectField,
  [FIELD_TYPE.MULTIPLE_CHOICE_LIST]: SelectField,
  [FIELD_TYPE.DATE]: DateField,
  [FIELD_TYPE.DATE_TIME]: DateField,
  [FIELD_TYPE.DATE_TIME_TIMEZONE]: DateField,
  [FIELD_TYPE.DATE_WITH_USER_TIMEZONE]: DateField,
  [FIELD_TYPE.DATE_WITH_TIMEZONE]: DateWithTimezoneField,
  [FIELD_TYPE.DECIMAL]: DecimalField,
  [FIELD_TYPE.NUMBER]: NumberField,
  [FIELD_TYPE.EMAIL]: EmailField,
  [FIELD_TYPE.FILE]: FileField,
  [FIELD_TYPE.NAME]: NameField,
  [FIELD_TYPE.RICH_TEXT]: RichTextField,
  [FIELD_TYPE.RICH_TEXT_EDITOR]: RichTextField,
  [FIELD_TYPE.CHECKBOX]: CheckboxField,
  [FIELD_TYPE.BOOLEAN]: CheckboxField,
  [FIELD_TYPE.ZIP]: ZipField,
  [FIELD_TYPE.STATE]: StateAsyncField,
  [FIELD_TYPE.COUNTY]: CountyAsyncField,
  [FIELD_TYPE.CITY]: CityAsyncField,
  [FIELD_TYPE.COUNTRY]: CountrySelectField,
  [FIELD_TYPE.ASSIGNMENT_METHOD]: AssignmentMethodField,
  [FIELD_TYPE.TAG]: TagField,
});

export const FIELD_REGISTRY = FIELD_COMPONENT_REGISTRY;

export function getFieldComponent(fieldType) {
  if (!fieldType) return null;
  return FIELD_COMPONENT_REGISTRY[String(fieldType).toLowerCase()] ?? null;
}